import { useEffect, useState } from "react";
import { ChangeEmailRequest } from "orderme-api-integration-client";
import { DialogProps } from "../../../interfaces/interfaces"
import { CustomerClient } from "../../../helpers/client";
import { Popup } from "../../popup/popup"
import { InputField } from "../../inputField/inputField";
import EmailIcon from '@mui/icons-material/Email';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from "../../../redux/hooks";
import { forceLoginAgain } from "../../../redux/reducers/authReducer";
import { isValidEmail } from "../../../helpers/validator";

export function EmailChange(props: DialogProps) {
  const dispatch = useAppDispatch();
  const { onClose, open } = props;
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const customersClient: CustomerClient = new CustomerClient();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null);
  const { t } = useTranslation('account');

  useEffect(() => {
    setIsButtonDisabled(!isValidEmail(email));
    setStatus(null);
  }, [email]);

  const change = async () => {
    try {
      const request = new ChangeEmailRequest({ email });
      await customersClient.changeEmail(request)
      setStatus(true);

      setTimeout(function () {
        setStatus(null);
        dispatch(forceLoginAgain());
      }, 3000);
    }
    catch (err) {
      setStatus(false);
      console.log(err);
    }
  }

  const handleOnClose = () => {
    setStatus(null);
    setEmail(null);
    onClose();
  }

  return (
    <Popup onClose={() => handleOnClose()} open={open} dialogTitle={t('changeEmail')} dialogContent={
      <InputField fieldName="email" placeholder={t('newEmailInput')} inputValue={email} handleFieldChange={(e) => setEmail(e.target.value)} icon={<EmailIcon />} />
    }
      onAction={() => change()}
      buttonContent={t('confirm')}
      isButtonDisabled={isButtonDisabled}
      isSuccess={status === true}
      successText={t('emailChanged')}
      isFailure={status === false}
    />
  );
}